import { IQuery } from 'core-ts-types';
import { IDefineCommand } from 'core-ts-types';
import { INotificationDelegate } from './../../global/helpers/notification_delegate';
import { APCustomText } from './../builders/custom_text_builder';
import { IAPCustomTextDatasource } from './../datasources/custom_text_datasource';

export type LoadCustomTextCommand = () => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-academic-planner')
  .service(
    'loadCustomTextCommand',
    (
      defineCommandORM: IDefineCommand,
      ngAPCustomTextDatasource: IAPCustomTextDatasource,
      ngAPNotificationDelegate: INotificationDelegate,
      log: any,
      $http: ng.IHttpService
    ) =>
      defineCommandORM('loadCustomTextCommand', (deferred) =>
        $http
          .get(`config/customtext/`)
          .then((response: any) => {
            ngAPCustomTextDatasource.clear().write(response.data);
            deferred.resolve();
          })
          .catch((e: any) => {
            const errorMessage = 'Failed to get custom texts for academic plan';
            ngAPNotificationDelegate.error(errorMessage);
            log.error(errorMessage);
            deferred.reject(e);
          })
      )
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/custom_texts/commands/load_custom_text_command.ts